import ua from '@tencent/docs-user-agent';

/**
 * 判断当前的浏览器是否有设置缩放，
 * 返回缩放的百分比值, 从sheet复制 spread-sheet/src/base/util/browser.ts
 */
export function getBrowserZoomLevel() {
    if (ua.isIE) {
        return getBrowserZoomLevelIE();
    }
    if (ua.isFirefox) {
        // FireFox无法通过devicePixelRatio或者window.outerWidth / window.innerWidth
        // 的值明确判断当前的缩放 故直接返回100
        return 100;
    }
    if (ua.isChrome || ua.isChromiumEdge) {
        return getBrowserZoomLevelChrome();
    }
    if (ua.isSafari) {
        return Math.round((window.outerWidth / window.innerWidth) * 100);
    }
    // 兜底逻辑 不太准确
    let ratio = 1;
    if (window.devicePixelRatio !== undefined) {
        // devicePixelRatio 一般情况下=1
        // 在Retina屏幕上=2
        // 在用户设置了系统缩放时等于系统缩放值（如Windows高分屏可能默认为1.25）
        ratio = window.devicePixelRatio;
    }
    if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
        // 利用window属性进行计算 用来修正mac的Retina屏幕
        const temp = window.outerWidth / window.innerWidth;
        if (Math.round(temp * 100) === 100) {
            ratio = 1;
        }
    }
    return Math.round(ratio * 100);
}
function getBrowserZoomLevelIE() {
    const { screen } = window as any;
    if (screen.deviceXDPI && screen.logicalXDPI) {
        return (screen.deviceXDPI / screen.logicalXDPI) * 100;
    }
    return 100;
}
function getBrowserZoomLevelChrome() {
    // 存在 devtools 或者浏览器侧边栏的时候会失效
    let temp = window.outerWidth / window.innerWidth;
    // Windows系统下的Chrome的outerWidth会比innerWidth略大，应该是包含了头部的像素，mac下无问题。
    if (ua.isWindows && Math.round(temp * 100) > 95 && Math.round(temp * 100) < 105) {
        temp = 1;
    }
    return Math.round(temp * 100);
}
